import instance from '@/utils/instance';

//获取微信支付二维码
export function getConsumerOrderPayWechat(params) {
	return instance({
		url: `/webL_api/consumer/order/pay/wechat/${params}`,
		method: 'get'
	});
}

//获取支付宝支付二维码
export function getConsumerOrderPayAlibaba(params) {
	return instance({
		url: `/webL_api/consumer/order/pay/alibaba/${params}`,
		method: 'get'
	});
}

//获取微信支付状态
export function getConsumerOrderPayWechatStatus(params) {
	return instance({
		url: `/webL_api/consumer/order/state/wechat/${params}`,
		method: 'get'
	});
}

//获取支付宝支付状态
export function getConsumerOrderPayAlibabaStatus(params) {
	return instance({
		url: `/webL_api/consumer/order/state/alibaba/${params}`,
		method: 'get'
	});
}

//上传付款凭证
export function postConsumerOrderPayOfflineTransfer(params) {
	return instance({
		url: `/webL_api/consumer/order/pay/corporate/upload`,
		method: 'post',
		data: params
	});
}
